import { Component } from "@angular/core";
import { Entity } from "breeze-client";
import { DialogBaseComponent, DialogParams } from "./dialog-base.component";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DomainService } from "./domain.service";

export interface AddressDialogParams extends DialogParams {
  entity: Entity;
  addressTypeName: string;
  addressPrefix: string;
  editable: boolean;
}

@Component({
  templateUrl: "./address-dialog.component.html",
  standalone: false,
})
export class AddressDialogComponent extends DialogBaseComponent<AddressDialogParams> {
  params: AddressDialogParams;

  constructor(
    public config: DynamicDialogConfig<AddressDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService
  ) {
    super(config, dialogRef, domainService);
    this.params = this.config.data;
    Object.assign(this.config, { width: "700px", height: "520px" });
    this.config.header = `Edit ${this.params.addressTypeName} Address`;
    this.isPageReady = true;
  }

  canSave() {
    return !this.params.entity.entityAspect.entityState.isUnchanged();
  }

  async saveChanges() {
    const entity = this.params.entity;
    if (!entity.entityAspect.validateEntity()) {
      const vErrors = entity.entityAspect.getValidationErrors();
      // remove it because its got errors and it will be recreated if they reedit it.
      const errMsg = vErrors.map((ve) => ve.errorMessage).join("<br>");
      await this.dialogService.showOkMessage("Validation Error(s)", errMsg);
      return false;
    }
    this.dbSaveService.saveSelectedChanges([this.params.entity], true);
    this.dialogRef.close(true);
  }

  cancelChanges() {
    this.params.entity.entityAspect.rejectChanges();
    this.dialogRef.close(false);
  }
}
